import { Injectable } from '@angular/core';
import { AbstractStateService } from '@tnq/shared/core';
import { addressSchema, IAddressState } from '../schemas';

@Injectable({
  providedIn: 'root',
})
export class AddressStateService extends AbstractStateService<IAddressState> {
  protected storageKey = 'tnq-customer-address';
  protected schema = addressSchema;
}
